<template>
  <div class="purchase-history-container infinite-list-page">
    <div class="record-filters">
      <div class="record-type-switch">
        <button
          v-for="tab in recordTypeTabs"
          :key="tab.value"
          class="type-button"
          :class="{ active: recordType === tab.value }"
          @click="switchRecordType(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>
      <div class="record-month-filter">
        <el-date-picker
          v-model="queryMonth"
          type="month"
          placeholder="请选择月份"
          value-format="YYYY-MM"
          format="YYYY年M月"
          :clearable="false"
          :disabled-date="disabledFutureMonth"
          @change="onQueryMonthChange"
        />
      </div>
    </div>

    <div class="infinite-list-page__body">
      <div class="infinite-list-page__content">
        <div v-if="loading && displayRecords.length === 0" class="empty-tip">加载中...</div>
        <div v-else-if="!loading && displayRecords.length === 0" class="empty-records">
          <el-empty description="暂无记录"></el-empty>
        </div>

        <template v-else>
          <div
            class="purchase-record"
            v-for="(record, index) in displayRecords"
            :key="record.id != null ? String(record.id) : 'ph-' + index"
          >
            <div class="record-content">
              <p class="record-title">{{ getTypeLabel(record.sourceType) }}</p>
              <div class="record-details">
                <span>{{ record.changeTime || '-' }}</span>
                <span class="separator">|</span>
                <span>变动金额: {{ formatAmount(record.changeAmount) }}</span>
                <span class="separator">|</span>
                <span>变动后余额: {{ record.balanceAfterAmount ?? 0 }}</span>
              </div>
              <p class="record-remark">{{ record.remark || '-' }}</p>
            </div>
            <span class="record-price">{{ formatAmount(record.changeAmount) }}</span>
          </div>
        </template>

        <div
          v-if="isMobile && displayRecords.length > 0 && !loading"
          ref="purchaseSentinel"
          class="infinite-sentinel"
          aria-hidden="true"
        />
        <p v-if="isMobile && loadingMore" class="infinite-loading-hint">加载中...</p>
      </div>
      <div
        v-if="showInfiniteEndTip"
        class="infinite-list-page__spacer"
        aria-hidden="true"
      />
    </div>

    <p v-if="showInfiniteEndTip" class="infinite-end-tip">
      <span class="infinite-end-tip-text">我也是有底线的</span>
    </p>

    <!-- 分页（仅桌面端） -->
    <div v-if="!isMobile && !loading && total > 0" class="pagination">
      <button class="page-button" @click="previousPage" :disabled="currentPage === 1 || loading">上一页</button>
      <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
      <button class="page-button" @click="nextPage" :disabled="currentPage === totalPages || loading">下一页</button>
    </div>
  </div>
</template>

<script setup>
import { usePurchaseHistory } from '@/features/user/composables/usePurchaseHistory'

const {
  loading,
  loadingMore,
  recordType,
  recordTypeTabs,
  queryMonth,
  isMobile,
  purchaseSentinel,
  currentPage,
  totalPages,
  total,
  displayRecords,
  showInfiniteEndTip,
  getTypeLabel,
  formatAmount,
  disabledFutureMonth,
  onQueryMonthChange,
  switchRecordType,
  previousPage,
  nextPage,
} = usePurchaseHistory()
</script>

<style scoped src="@/features/user/styles/operationArea/PurchaseHistory.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
